import React, { FC } from 'react';
import {
  globalSearchEndDateState,
  globalSearchStartDateState,
} from '../../../store/global-search.context';
import { useGlobalSearchValues } from '../../../store/recoil/global-search';
import { useTranslation } from 'next-i18next';
import styles from './page-header-info.module.scss';
import { Icon } from '@digando/react-component-library';
import classNames from 'classnames';
import { useRecoilState } from 'recoil';
import { isPageHeaderSearchDropdownVisibleState } from './global-search.state';

export const PageHeaderInfo: FC = () => {
  const [startDate] = useRecoilState(globalSearchStartDateState);
  const [endDate] = useRecoilState(globalSearchEndDateState);
  const { location, term } = useGlobalSearchValues();
  const [t] = useTranslation(['search-component', 'common']);
  const [isPageHeaderSearchDropdownVisible, setIsPageHeaderSearchDropdownVisibleState] = useRecoilState(isPageHeaderSearchDropdownVisibleState);

  const handleClick = (): void => {
    setIsPageHeaderSearchDropdownVisibleState(!isPageHeaderSearchDropdownVisible);
  };

  return (
    <div className={styles.pageHeaderInfoWrapper} onClick={handleClick}>
      <div className={styles.pageHeaderInfo}>
        <div className={styles.term}>{term?.value ? term?.value : t('search-component:label-search-term')}</div>
        <div
          className={styles.location}>{location?.name ? (location?.name + ',') : t('search-component:label-search-location')}</div>

        <div className={styles.dateWrapper}>
          <span>{startDate.format('DD.MM.YY')}-</span>
          <span>{endDate.format('DD.MM.YY')}</span>
        </div>
      </div>

      <div className={classNames({
        [styles.dropdown]: true,
        [styles.isVisible]: isPageHeaderSearchDropdownVisible,
      })}>
        <Icon icon='dropdown' color={`var(--black)`} size={'20px'} />
      </div>
    </div>
  );
};

